export function ClearFormattingIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M14.8287 1.99455C15.0571 1.76605 15.0571 1.39655 14.8287 1.17047C14.6002 0.944394 14.2308 0.941963 14.0048 1.17047L9.14408 6.03232L8.83057 5.71873C8.33964 5.22768 7.58137 5.12072 6.97622 5.45862L1.39858 8.55562C1.15311 8.69175 1 8.95186 1 9.23385C1 9.43804 1.08263 9.63738 1.22602 9.7808L6.21795 14.7739C6.36377 14.9198 6.56063 15 6.76721 15C7.04913 15 7.30917 14.8469 7.44527 14.6013L10.5415 9.02479C10.8794 8.41706 10.7724 7.66104 10.2815 7.16999L9.96797 6.8564L14.8287 1.99455ZM8.00425 6.54281L9.45517 7.99408C9.57912 8.11805 9.60342 8.30523 9.52079 8.45838L9.15867 9.10987L6.88872 6.83939L7.54006 6.47718C7.69074 6.3921 7.88031 6.41884 8.00425 6.54281ZM5.82666 7.4301L8.56809 10.1722L6.67485 13.5828L4.32957 11.2369L4.76703 9.92666C4.81807 9.77351 4.67225 9.63009 4.52157 9.68114L3.21161 10.1187L2.42175 9.32865L5.83152 7.43496L5.82666 7.4301Z"
        fill="currentColor"
      />
    </svg>
  );
}
